import icon from "../../assets/power-backup.svg";
import type { Property } from "../../types";

export const powerRedundancy: Property = {
  id: "powerRedundancy",
  title: "powerRedundancy.title",
  icon,
};
